import MenuModel from '../../models/Menu';

const GET_MENU_LIST = 'GET_MENU_LIST';

/**
 * 获取菜单列表
 */
async function getMenuList() {
  const payload = await new MenuModel().menuList();
  return {
    type: GET_MENU_LIST,
    payload
  }
}

const ACTION_TYPES = {
  GET_MENU_LIST,
};

const ACTION = {
  getMenuList
};

const Menu = {
  ACTION_TYPES,
  ACTION
}

export default Menu;